import { Logo } from "./Logo";
import { useContent } from "@/context/ContentContext";
import { useText } from "@/lib/useText";

export function Footer() {
  const { content } = useContent();
  const t = useText();
  const links = content?.links || {};
  return (
    <footer className="border-t border-eden-border bg-eden-bg" data-testid="site-footer">
      <div className="container-eden flex flex-col gap-8 py-12 md:flex-row md:items-start md:justify-between">
        <div className="space-y-4">
          <Logo url={content?.media?.logo_url} className="h-8" textClass="text-lg" />
          <p className="max-w-xs text-sm leading-relaxed text-eden-muted">
            {t("footer_tagline")} <span className="font-mono text-eden-secondary">{links.fivem_code || "zjj9jqp"}</span>.
          </p>
        </div>
        <nav aria-label="Ligações do rodapé" className="flex gap-10 text-sm">
          <ul className="space-y-3">
            <li><a href={links.discord_invite} target="_blank" rel="noopener noreferrer" className="text-eden-secondary transition-colors hover:text-eden-text" data-testid="footer-discord-link">{t("footer_discord")}</a></li>
            <li><a href={links.tebex} target="_blank" rel="noopener noreferrer" className="text-eden-secondary transition-colors hover:text-eden-text" data-testid="footer-tebex-link">{t("footer_store")}</a></li>
          </ul>
          <ul className="space-y-3">
            <li><a href="/regras" className="text-eden-secondary transition-colors hover:text-eden-text" data-testid="footer-rules-link">{t("nav_rules")}</a></li>
            <li><a href="/informacoes" className="text-eden-secondary transition-colors hover:text-eden-text" data-testid="footer-info-link">{t("nav_info")}</a></li>
            <li><a href="/precario" className="text-eden-secondary transition-colors hover:text-eden-text" data-testid="footer-pricing-link">{t("nav_pricing")}</a></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-eden-borderSubtle">
        <div className="container-eden flex flex-col gap-2 py-5 text-xs text-eden-muted sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {t("footer_copyright")}</p>
          <p data-testid="footer-disclaimer">{t("footer_disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}
